export default __webpack_public_path__ + "static/media/complementary--time-restrictions--g3.4c6120b8.png";